(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTitleBarCheckboxButton', drvTitleBarCheckboxButton);

    drvTitleBarCheckboxButton.$inject = [];

    /**
     * @ngdoc directive
     * @name drvTitleBarCheckboxButton
     * 
     * @description
     * Creates a title bar checkbox button.
     * To be used with drvTitleBar.
     *
     * # Scope Properties
     * {bool} value - The checkbox value.
     * {string} text - Text to be shown for the button. Optional.
     * {string} caption - Caption to be shown for the button. Optional.
     * {bool} disabled - Disables the button. Optional.
     */
    function drvTitleBarCheckboxButton() {
        var directive = {
            restrict: 'E',
            scope: {
                text: '<?',
                value: '=',
                caption: '<?',
                disabled: '<?'
            },
            template:
                '<div drv-tool-tip="caption" class="title-bar-button" style="margin-top: 4px; color: rgba(0, 0, 0, 0.87);">' +
                '   <md-checkbox style="margin-bottom: 0px;" ng-model="value" ng-disabled="disabled" aria-label="{{text ? text : \'Checkbox\'}}">' +
                '       {{text}}' +
                '   </md-checkbox>' +
                '</div>'
        };
        return directive;
    }
})();